const findOptionSettings = ({
  remittanceOptions, countryCode, currencyCode, remittanceMethod,
}) => remittanceOptions.filter(ro => ro.countryCode === countryCode
    && ro.currencyCode === currencyCode
    && ro.remittanceMethod === remittanceMethod).map(ro => ro.remittanceOptionSettingList).pop() || []

export default findOptionSettings
